import React from 'react';
import styled from 'styled-components';
import Modal from '../../containers/common/Modal';
import crossIcon from '../../images/cross_icon.svg';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Sheet = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px 8px;
  border-bottom: 1px solid #ececec;
`;

const Title = styled.div`
  font-family: var(--font-primary), 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: #343239;
  word-break: break-word;
`;

const CloseButton = styled.button`
  flex-shrink: 0;
  width: 25px;
  height: 25px;
  padding: 0;
  border: none;
  background: transparent;
  line-height: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => p.columns}, minmax(0, 1fr));
  column-gap: 11px;
  row-gap: 12px;
  padding: 12px;
`;

const Tile = styled.div`
  background: ${(p) => p.bg};
  border-radius: 10.9px;
  min-height: 104px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
`;

const TileIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const TileLabel = styled.div`
  font-family: var(--font-primary), 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  color: ${(p) => p.color};
  text-align: center;
`;

export default function CardGridModal({
  title,
  cards = [],
  columns = 2,
  tileBg = '#f2dae5',
  labelColor = '#030047',
  onCardClick,
  onClose,
}) {
  if (!cards.length) return null;
  return (
    <Modal>
      <Backdrop onClick={onClose}>
        <Sheet onClick={(e) => e.stopPropagation()}>
          <Header>
            {title ? <Title>{title}</Title> : <div />}
            <CloseButton type="button" aria-label="Close" onClick={onClose}>
              <img src={crossIcon} alt="" width={25} height={25} />
            </CloseButton>
          </Header>
          <Grid columns={columns}>
            {cards.map((card) => (
              <Tile
                key={card.cardKey || card.cardType || card.title}
                bg={tileBg}
                onClick={() => onCardClick && onCardClick(card)}
              >
                {card.imageUrl ? (
                  <TileIcon src={card.imageUrl} alt={card.title} />
                ) : null}
                <TileLabel color={labelColor}>{card.title}</TileLabel>
              </Tile>
            ))}
          </Grid>
        </Sheet>
      </Backdrop>
    </Modal>
  );
}
